import { httpClient } from '@/services/http/httpClient'

type Params = {
  ideaId: string
  evaluations: {
    criteriaId: string
    name: string
    rate: number
  }[]
}

export async function evaluateIdeaCriteria({ ideaId, evaluations }: Params) {
  const criteriaEvaluations = evaluations.map((evaluation) => ({
    evaluationCriteriaId: evaluation.criteriaId,
    evaluationName: evaluation.name,
    evaluationRate: evaluation.rate,
  }))

  await httpClient.post(`/ideas/evaluations/criteria/${ideaId}/evaluations`, {
    criteriaEvaluations,
  })
}
